import { ButtonSize, ButtonWidth, FAIcon, useBreakpoint } from '@nextgen-web-framework/all';
import styles from './ButtonLoader.module.scss';
import { ButtonLoaderProps } from './types/propsType';

export const ButtonLoader = ({
  size = ButtonSize.MEDIUM,
  width = ButtonWidth.FIT_CONTENT,
  componentClassName,
}: ButtonLoaderProps) => {
  const viewPortType = useBreakpoint();
  const className = ['md'].indexOf(viewPortType) !== -1 ? componentClassName : '';

  const fitContentClass = `${styles['button-loader-container-fit-content']} ${
    className ? styles['button-loader-container-updatepassword'] : ''
  }`;
  const fullWidthClass = `${styles['button-loader-container-full-width']}`;

  return (
    <div
      data-testid="button-loader-test-id"
      className={`${styles['button-loader-container']} ${
        size === ButtonSize.SMALL ? styles['button-loader-container-small'] : styles['button-loader-container-medium']
      } ${width === ButtonWidth.FIT_CONTENT ? fitContentClass : fullWidthClass}`}
    >
      <div className={styles['button-loader-container-icon-container']}>
        <FAIcon className={styles['button-loader-container-icon']} iconName="spinner-third" />
      </div>
    </div>
  );
};
